import { Injectable } from '@angular/core';
import { HttpServiceBundle } from '@app/core/services/base/http-service-bundle.service';
import { Observable } from 'rxjs';
import { BaseHttpWithBundleService } from '@app/core/services/base/base-service-with-bundle.service';
import { map } from 'rxjs/operators';
import { BackendUriUnits } from '@app/core/services/base/backend-uri-units';
import { CaseLogsContainer } from '@app/shared/models/log';
import { DRResponse } from '@app/shared/models/response';
import { DrI18nService } from '@app/core/services/i18n/i18n.service';
import { TranslationEntry } from '@app/shared/models/translatable';


@Injectable({ providedIn: 'root' })
export class CaseLogService extends BaseHttpWithBundleService {

    constructor(httpServiceBundle: HttpServiceBundle, protected drI18nService: DrI18nService) {
        super(httpServiceBundle);
        this.uri += `/${BackendUriUnits.CASES}`;
    }

    public getCaseLogCategories(): Observable<TranslationEntry[]> {
        const uri = `${this.uri}/${BackendUriUnits.ACTIVITY_LOG}/categories`;
        const params = {
            locale: DrI18nService.getActiveLocaleInformation().shortName
        };

        return this.http.get<DRResponse<any>>(uri, { params: params })
                        .pipe(map(result => {
            return Object.entries(result.data)
                         .map(([key, value]) => {
                return { key: key, trans: value as string };
            });
        }));
    }

    public getCaseLogs(caseId: string, categoryKey?: string, userId?: string, search?: string,
                       locale: string = DrI18nService.getActiveLocaleInformation().shortName): Observable<CaseLogsContainer> {
        const uri = `${this.uri}/${caseId}/${BackendUriUnits.ACTIVITY_LOG}`;
        const params: any = {
            locale: locale
        };

        if (categoryKey) {
            params.category = categoryKey;
        }

        if (userId) {
            params.userId = userId;
        }

        if (search) {
            params.search = search;
        }

        return this.http.get<DRResponse<CaseLogsContainer>>(uri, { params: params })
                        .pipe(map(res => new CaseLogsContainer(res.data)));
    }

}
